import { render } from "./inputBase.vue?vue&type=template&id=61b56d44"
import script from "./inputBase.vue?vue&type=script&lang=js"
export * from "./inputBase.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__